import * as React from 'react';

const AuthenticityDiamond32Dark = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 32 32", width: 32, height: 32, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("circle", { cx: 16, cy: 16, r: 16, fill: "#2B3233" }), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#449DA9",
    d: "M14.484 23.51a2 2 0 0 0 3.035 0l6.367-7.412a2 2 0 0 0 .004-2.601l-2.79-3.269a2 2 0 0 0-1.52-.702h-7.156a2 2 0 0 0-1.521.702l-2.79 3.269a2 2 0 0 0 .004 2.601z"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "#F3F3F3",
    d: "M18.433 12.651c.064-.557.846-.557.91 0l.135 1.172a.466.466 0 0 0 .402.414l1.135.14c.54.065.54.873 0 .94l-1.135.139a.466.466 0 0 0-.402.414l-.135 1.172c-.064.556-.846.556-.91 0l-.135-1.172a.466.466 0 0 0-.401-.414l-1.136-.14c-.54-.066-.54-.874 0-.94l1.136-.139a.466.466 0 0 0 .4-.414z"
  }
));
AuthenticityDiamond32Dark.Size = 32;
AuthenticityDiamond32Dark.Title = "AuthenticityDiamond";

export { AuthenticityDiamond32Dark as default };
